import React from "react";

import StringArgValue from "./values/string";
import TextMapArgValue from "./values/text_map";
import WorkflowInputValues from "./values/workflow_input_values";

import {EnhancedLlmRun} from "common/flowmaster/types/llm_run";
import {
  ActionDefinitionArg,
  SelectValuesArgument,
  StringArgument,
  TaskArgument,
  TextMapArgument,
  WorkflowInputValuesArgument,
  DecisionQuestionsArgument,
} from "common/flowmaster/types/task_config";
import {Prompt} from "common/flowmaster/types/workflow";

interface Props {
  actionArg: ActionDefinitionArg;
  llmRun: EnhancedLlmRun;
  arg: TaskArgument | null;
  prompts: Prompt[];
}

export default function ArgumentValue({
  actionArg,
  arg,
  llmRun,
  prompts,
}: Props) {
  if (
    actionArg.type === "string" ||
    actionArg.type === "int" ||
    actionArg.type === "model_select"
  ) {
    return (
      <StringArgValue
        arg={(arg as StringArgument)?.value}
        llmRun={llmRun}
        prompts={prompts}
      />
    );
  } else if (actionArg.type === "select") {
    return <div>{(arg as SelectValuesArgument)?.value?.key}</div>;
  } else if (actionArg.type === "text_map") {
    return (
      <TextMapArgValue
        arg={(arg as TextMapArgument)?.value}
        llmRun={llmRun}
        prompts={prompts}
      />
    );
  } else if (actionArg.type === "workflow_input_values") {
    return (
      <WorkflowInputValues
        arg={(arg as WorkflowInputValuesArgument)?.value}
        llmRun={llmRun}
        prompts={prompts}
      />
    );
  } else if (actionArg.type === "json_schema") {
    return <span>"see output"</span>;
  } else if (actionArg.type === "decision_questions") {
    const rows = (arg as DecisionQuestionsArgument | null)?.value;
    if (!Array.isArray(rows)) {
      return <span>checks from another task or input</span>;
    }
    const switchedOn = rows.filter(row => row?.enabled !== false);
    return (
      <span>{`${rows.length} checks, ${
        switchedOn.length
      } switched on: ${switchedOn.map(row => row.name).join(", ")}`}</span>
    );
  } else {
    return (
      <div>
        unknown type: ${actionArg.type} ${JSON.stringify(arg)}
      </div>
    );
  }
}
